import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SpaceJetNetwork from "./pages/SpaceJetNetwork.jsx";
import SpaceJetNetworkAdvertisers from "./pages/SpaceJetNetworkAdvertisers.jsx";
import SpaceJetNetworkAffiliates from "./pages/SpaceJetNetworkAffiliates.jsx";
import LinkTrustMarketplace from "./pages/LinkTrustMarketplace.jsx";
import SpaceJetNetworkContact from "./pages/SpaceJetNetworkContact.jsx";
import SpaceJetNetworkLogin from "./pages/SpaceJetNetworkLogin.jsx";
import SpaceJetNetworkSignup from "./pages/SpaceJetNetworkSignup.jsx";
import SpaceJetNetworkSignupSuccess from "./pages/SpaceJetNetworkSignupSuccess.jsx";
import SpaceJetNetworkSignupFailure from "./pages/SpaceJetNetworkSignupFailure.jsx";
import SpaceJetNetworkClientSignup from "./pages/SpaceJetNetworkClientSignup.jsx";
import SpaceJetNetworkPendingApproval from "./pages/SpaceJetNetworkPendingApproval.jsx";

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-slate-900">
        <Routes>
        <Route path="/" element={<SpaceJetNetwork />} />
        <Route path="/linktrust-marketplace" element={<LinkTrustMarketplace />} />
        <Route path="/advertisers" element={<SpaceJetNetworkAdvertisers />} />
        <Route path="/affiliates" element={<SpaceJetNetworkAffiliates />} />
        <Route path="/contact" element={<SpaceJetNetworkContact />} />
        <Route path="/login" element={<SpaceJetNetworkLogin />} />
        <Route path="/signup" element={<SpaceJetNetworkSignup />} />
        <Route path="/signup-success" element={<SpaceJetNetworkSignupSuccess />} />
        <Route path="/signup-failure" element={<SpaceJetNetworkSignupFailure />} />
        <Route path="/client-portal" element={<Navigate to="/login" replace />} />
        <Route path="/client-portal/signup" element={<SpaceJetNetworkClientSignup />} />
        <Route path="/pending-approval" element={<SpaceJetNetworkPendingApproval />} />
        <Route path="/tracking-tester" element={<Navigate to="/login" replace />} />
        <Route path="/tracking-tester-debug" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
